// extracted by mini-css-extract-plugin
module.exports = {"guidelines":"Guidelines_guidelines__rsiu3","content":"Guidelines_content__hQIG6"};